import { Badge } from "../ui/badge";
import { ScrollArea } from "../ui/scroll-area";

export function HistoryTab({ opportunities, setSelectedOpportunity, setActiveTab, getRiskColor, isDark }) {
  return (
    <div className="animate-fade-in" data-testid="history-content">
      <div className={`rounded-xl border ${isDark ? 'bg-[#12121a] border-white/10' : 'bg-white border-gray-200'}`}>
        <div className={`p-4 border-b ${isDark ? 'border-white/10' : 'border-gray-200'}`}>
          <h2 className={`text-lg font-bold ${isDark ? 'text-white' : 'text-gray-900'}`}>Opportunity History</h2>
          <p className={`text-sm font-body ${isDark ? 'text-gray-500' : 'text-gray-400'}`}>Review past opportunities and their performance</p>
        </div>
        <ScrollArea className="h-[600px]">
          <div className={`divide-y ${isDark ? 'divide-white/5' : 'divide-gray-100'}`}>
            {opportunities.map((opp) => (
              <button
                key={opp.id}
                onClick={() => {
                  setSelectedOpportunity(opp);
                  setActiveTab("dashboard");
                }}
                className={`w-full p-4 transition-colors text-left ${isDark ? 'hover:bg-white/5' : 'hover:bg-gray-50'}`}
                data-testid={`history-item-${opp.id}`}
              >
                <div className="flex items-start justify-between">
                  <div className="flex-1">
                    <div className="flex items-center gap-2 mb-1">
                      <Badge variant="outline" className={`text-xs ${isDark ? 'border-purple-500/30 text-purple-300' : ''}`}>{opp.category}</Badge>
                      <Badge className={getRiskColor(opp.risk_level)}>{opp.risk_level}</Badge>
                      {opp.is_todays_opportunity && (
                        <Badge className="bg-emerald-500 text-white text-xs">Today</Badge>
                      )}
                    </div>
                    <h3 className={`font-bold mb-1 ${isDark ? 'text-white' : 'text-gray-900'}`}>{opp.title}</h3>
                    <p className={`text-sm font-body line-clamp-1 ${isDark ? 'text-gray-500' : 'text-gray-400'}`}>{opp.summary}</p>
                  </div>
                  <div className="text-right ml-4">
                    <p className="text-lg font-bold text-purple-500">{Math.round(opp.probability_score * 100)}%</p>
                    <p className={`text-xs font-body ${isDark ? 'text-gray-600' : 'text-gray-400'}`}>
                      {new Date(opp.created_at).toLocaleDateString()}
                    </p>
                  </div>
                </div>
              </button>
            ))}
          </div>
        </ScrollArea>
      </div>
    </div>
  );
}
